// extracted by mini-css-extract-plugin
export var gradientOverlay = "styles-module--gradientOverlay--c6418";
export var left = "styles-module--left--db6cb";
export var right = "styles-module--right--2ead1";
export var selectedTab = "styles-module--selectedTab--be49a";
export var tab = "styles-module--tab--0c73a";
export var tabList = "styles-module--tabList--e7980";
export var tabListContainer = "styles-module--tabListContainer--abea1";